import { render, staticRenderFns } from "./WfDevPublishMsgModal.vue?vue&type=template&id=722888ee&"
import script from "./WfDevPublishMsgModal.vue?vue&type=script&lang=js&"
export * from "./WfDevPublishMsgModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports